module.exports = __webpack_public_path__ + "img/assistant.5542ab8a.gif";